var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionLocationList", {
        attrs: {
          xs12: "",
          locationList: _vm.locationList,
          clientList: _vm.clientList,
          sourceList: _vm.sourceList,
          shouldShowSearch: true,
          toolbarActions: [
            {
              text: "Location",
              icon: "add",
              iconColor: "success",
              emitEvent: "onAddNewLocationClicked",
            },
          ],
          isLoading: _vm.isLoading,
        },
        on: {
          onAddNewLocationClicked: function ($event) {
            _vm.showDialogFormLocationAdd = true
          },
          onEditLocationClicked: (val) => [
            (_vm.locationToEdit = val.locationToEdit),
            (_vm.showDialogFormLocationEdit = true),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormLocationAdd", {
        attrs: {
          showDialog: _vm.showDialogFormLocationAdd,
          clientList: _vm.clientList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormLocationAdd = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormLocationAddSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormLocationEdit", {
        attrs: {
          showDialog: _vm.showDialogFormLocationEdit,
          clientList: _vm.clientList,
          locationToEdit: _vm.locationToEdit,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormLocationEdit = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormLocationEditSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }